import { LatLngTuple } from "leaflet";
import React, { useContext, useMemo } from "react";
import {
    Marker, Popup
} from 'react-leaflet';
import SimpleImageSlider from "react-simple-image-slider";
import { MapDataContext } from '../context/map-data';
import { Validation } from '../core/global';
import { createMarkerIcon } from '../helpers/marker-icons';
import useLoggedIn from '../hooks/useLoggedIn';
import styles from "../styles/components/validation-points.module.scss";
import { Img } from "./image";
import { LoginPanel } from './login-panel';

const blockViewForNotLoggedIn = false

export const ValidationPoints = ( ) => {
  const { 
    validations,
    privateValidations,
    showValidations,
    privateValidationsSuperAdmin,
    showValidationsSuperAdmin,
  } = useContext(MapDataContext);
  const isLoggedIn = useLoggedIn()
  
  const merged = useMemo(() => {
    let mergedAll: Validation[] = []
    if (showValidations) {
      mergedAll = [...validations, ...privateValidations]
    }
    if (showValidationsSuperAdmin) {
      mergedAll = [...mergedAll, ...privateValidationsSuperAdmin]
    }
    // filter, only unique id is allowed, ignore ones with id as null
    const ids: number[] = []
    const filteredValidations = mergedAll.filter( validation => {
      if (ids.indexOf(validation.id) === -1 && validation.id !== null) {
        ids.push(validation.id)
        return true
      }
      return false
    })
    return filteredValidations
  }, [validations, privateValidations, privateValidationsSuperAdmin, showValidations, showValidationsSuperAdmin])


  if (typeof window === "undefined") {
    return null
  }

  return (
    <>
      {
        merged.map((validation: Validation) => {
          const {geom, file, name, id, type, organisation_id} = validation
          // TODO: implement private validation points
          // when organisation_id is not null, this indicates a private validation, and will only be shown if user is logged in and belongs to the organisation
          const found = merged.filter( r => r.geom === geom)
          if (found.length === 0) {
            return null
          }
          const isMultiple = found.length > 1
          // Only show first one in the list
          if (isMultiple) {
            if (found[0].id !== id ) {
              return null
            }
          }
          const [lon, lat] = geom.replace(/(POINT)|[()]/gi, '').split(' ')
          const point:LatLngTuple = [Number(lat), Number(lon)]

          const url = file?.indexOf('https:') === -1 ?
          `https://lon1.digitaloceanspaces.com/map-tiles/validations/${file}`
          : file || ''
          
          return (
            <React.Fragment key={`${id}-${name}`}>
              <Marker 
                icon={createMarkerIcon(isMultiple? 'plus' : type)} 
                opacity={1} 
                position={point}
              >
                <Popup maxWidth={720} minWidth={620} className={styles.popUpImage}>
                  
                  {isMultiple ?
                    <>
                      <h3>{name}; {found.map( r => r.type).join(', ')} validations</h3>
                      {(!isLoggedIn && blockViewForNotLoggedIn) ? 
                        <>
                          <LoginPanel className={styles.validationLoginPanel} absolute={false} message="**Login** or **create a free account** to see validation charts." />
                        </> 
                      :
                      <div className={styles.sliderWrapper}>
                        <SimpleImageSlider
                          width={670}
                          height={420}
                          images={[...found.map( r => r.file?.indexOf('https:') === -1 ?
                            `https://lon1.digitaloceanspaces.com/map-tiles/validations/${r.file}`
                            : r.file || '').reverse()]
                          }
                          showBullets={false}
                          showNavs={true}
                          navStyle={1}
                          navSize={25}
                        />
                      </div>
                      }
                    </>
                  : 
                    <>
                      <h3>{name}; {type} validation</h3>
                      {(!isLoggedIn && blockViewForNotLoggedIn) ? 
                        <>
                          <LoginPanel className={styles.validationLoginPanel} absolute={false} message="**Login** or **create a free account** to see validation charts." />
                        </> 
                      :
                        <Img 
                          enableSave
                          src={url} 
                          alt="validation" 
                          width={621}
                          height={366}
                        />
                      }
                    </>
                  }
                </Popup>
              </Marker>
            </React.Fragment>
          )
      })
    }
    </>
  );

};